var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import classNames from "classnames";

import styles from "./InternalLoadLink.css";

var InternalLoadLink = function (_Component) {
  _inherits(InternalLoadLink, _Component);

  function InternalLoadLink() {
    _classCallCheck(this, InternalLoadLink);

    return _possibleConstructorReturn(this, (InternalLoadLink.__proto__ || Object.getPrototypeOf(InternalLoadLink)).apply(this, arguments));
  }

  _createClass(InternalLoadLink, [{
    key: "render",
    value: function render() {
      return React.createElement(
        "a",
        { role: "button",
          name: this.props.name,
          href: this.props.href,
          className: classNames(styles.root, this.props.className, this.props.identifier) },
        this.props.children
      );
    }
  }]);

  return InternalLoadLink;
}(Component);

export default InternalLoadLink;


// WEBPACK FOOTER //
// ./src/components/Library/InternalLoadLink/InternalLoadLink.js